'use strict';

module.exports = function ( resource, config ) {
    var params = [],
        key;

    config = config || {};

    for ( key in config ) {
        if ( key && config[key] ) {
            params.push(key + '=' + config[key]);
        }
    }

    return resource + '?' + params.join('&');
};
